import type { FC } from 'react';
import React, { useEffect } from 'react';
import { Mobile, useTracking } from '@edreamsodigeo/frontend-core';

import { FLIGHT_FLIGHTSUMMARY_LABEL_PAGE } from '@/clientState/providers/TrackingProviders';
import FreeCancellationDrawerProvider from '@/clientState/providers/FreeCancellationDrawerProvider';
import { FreeCancellationBannerMobile } from './Banner';
import FreeCancellationDrawerPay from './Drawer/FreeCancellationDrawerPay';

const FreeCancellationFlightSummaryMeta: FC = () => {
  const { trackEvent } = useTracking();

  useEffect(() => {
    trackEvent({
      action: '24h-cancellation-msg',
      label: `24h-cancellation-msg_onload_pag:${FLIGHT_FLIGHTSUMMARY_LABEL_PAGE}`,
    });
  }, [trackEvent]);

  return (
    <>
      <FreeCancellationDrawerProvider>
        <Mobile>
          <FreeCancellationBannerMobile
            labelPage={FLIGHT_FLIGHTSUMMARY_LABEL_PAGE}
          />
        </Mobile>
        <FreeCancellationDrawerPay />
      </FreeCancellationDrawerProvider>
    </>
  );
};

export default FreeCancellationFlightSummaryMeta;
